import React from 'react';

const Ppt = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <title>ppt</title>
      <path
        fill="#d24726"
        d="M19 0v3.5h12c0.52 0 0.947 0.397 0.995 0.904l0.005 0.096v22.5c0 0.52-0.397 0.947-0.904 0.995l-0.096 0.005h-12v4l-19-3.5v-25l19-3.5zM31 4.5h-12l0 4.416c0.566-0.247 1.186-0.393 1.838-0.413l0.162-0.003v5h5c0 2.761-2.239 5-5 5-0.711 0-1.387-0.148-2-0.416l-0 1.916h8.5v1.5h-8.5v1.5h8.5v1.5h-8.5v2.5h12v-22.5zM22 7.5c2.707 0 4.912 2.152 4.997 4.838l0.003 0.162h-5v-5z"
      ></path>
      <path
        fill="#fff"
        d="M9.458 9.476c0.525-0.016 1.051 0.039 1.562 0.164 0.496 0.122 0.956 0.363 1.34 0.7 0.374 0.345 0.656 0.778 0.82 1.26 0.279 0.884 0.348 1.82 0.2 2.735-0.048 0.283-0.123 0.561-0.225 0.83-0.099 0.259-0.224 0.507-0.375 0.74-0.144 0.231-0.312 0.448-0.5 0.645-0.409 0.41-0.904 0.725-1.45 0.92-0.282 0.102-0.573 0.176-0.87 0.22-0.238 0.035-0.479 0.055-0.719 0.060v0l-1.241-0v4.25l-2.5-0.125v-12.19l3.7-0.21-0.005 0.015zM8.948 11.666l-0.173 0.004-0.775 0.080v3.75l0.78 0.090 0.174-0.003c0.231-0.011 0.46-0.052 0.681-0.122 0.234-0.076 0.446-0.206 0.62-0.38 0.172-0.178 0.301-0.394 0.375-0.63 0.089-0.286 0.131-0.585 0.125-0.885 0.006-0.292-0.036-0.582-0.125-0.86-0.147-0.468-0.525-0.827-1-0.95-0.167-0.045-0.338-0.075-0.51-0.087v0l-0.172-0.007z"
      ></path>
    </svg>
  );
};

export default Ppt;
